/**
 * Simple function that makes displaying quantities simpler and more readable. Note this function is
 * not meant to be I18n ready and is intended only for hard-coded, English strings
 * @param quantity The quantity to show
 * @param base The shared base between plural and singular
 * @param pluralSuffix The suffix to add to plural (!==1) quantities
 * @param singularSuffix The suffic to add to singular (===1) quantities
 * @param includeQuantity Whether to include the quantity number in the output
 */
export function pluralizeString(
  quantity: number,
  base: string,
  pluralSuffix = 's',
  singularSuffix = '',
  includeQuantity = true,
) {
  const suffix = quantity === 1 ? singularSuffix : pluralSuffix;
  const baseWithSuffix = `${base}${suffix}`;

  return includeQuantity ? `${quantity} ${baseWithSuffix}` : baseWithSuffix;
}
